module.exports = __webpack_public_path__ + "static/media/story-5.c281b75e.jpg";